/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cad_Page_Online_DescriptionInputs */

const en_cad_page_online_description = /** @type {(inputs: Cad_Page_Online_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open DWG and DXF drawings in your browser for free. No install or account required. DWG converts locally on your device (up to 20 MB); edit and save a DXF copy.`)
};

/**
* | output |
* | --- |
* | "Open DWG and DXF drawings in your browser for free. No install or account required. DWG converts locally on your device (up to 20 MB); edit and save a DXF copy." |
*
* @param {Cad_Page_Online_DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const cad_page_online_description = /** @type {((inputs?: Cad_Page_Online_DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cad_Page_Online_DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cad_page_online_description(inputs)
});
export { cad_page_online_description as "cad.page.online.description" }